/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of StoreBanner
 * Alfapeople -Customisation object -For Stor selection page
 */

import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';

export interface ISteps {
  stepDescription?: string;
  stepImage?: string;
}

/**
 *
 * StoreBanner component
 * @extends {React.PureComponent<IOurStoresProps<IOurStoresData>>}
 */
export class Steps extends Component {
  private readonly stepList: ISteps[] = [
    {
      stepDescription:
        'colored t-shirt<br/>felt and/or foam paper<br/>hot glue gun<br/>scissors<br/>favorite superhero toy!',
      stepImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1ZYM',
    },
    {
      stepDescription:
        'Cut off each sleeve diagonally toward the collar. Trim halfway around the collar to cut off front of shirt.',
      stepImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1Urz',
    },
    {
      stepDescription:
        'Design and cut decorative shapes out of felt. Parent-only step: hot glue decorations to shirt.',
      stepImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1ZYL',
    },
    {
      stepDescription:
        'Grab a toy, like a Batman figure, and take off to catch villains!',
      stepImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1Xsn',
    },
  ];
  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        <div className='row'>
          <h5 className='diy-small-heading-padding0'>What You’ll Need:</h5>

          {this.stepList.map((item) => (
            <React.Fragment>
              <div className='col-lg-12 col-md-12'>
                <div className='step-text'>
                  <p>{ReactHtmlParser(item.stepDescription)}</p>
                </div>
              </div>
              <div className='col-lg-12 col-md-12'>
                <div className='step-image'>
                  <img
                    className='img-responsive'
                    src={item.stepImage}
                    alt='bay doll sleeping bag'
                  />
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
      </React.Fragment>
    );
  }
}

export default Steps;
